import React from "react"
import { InputGroup } from "react-bootstrap"
import TaskDynamicFormTypes from "src/pages/dynamic_forms/Types/TaskDynamicFormTypes"
import DynamicFormsCustomRadio from "src/pages/dynamic_forms/Utils/CustomRadio/DynamicFormsCustomRadio"
import taskHelper from "../../taskHelper"
import "./TaskDynamicFormOptionsGroup.css"

interface Props {
    manageParentState: Function
    taskBoiler: TaskDynamicFormTypes
    DistributionGroups: Array<{
        PortalDynamicFormDistributionGroupId: number,
        Name: string
    }>
    checkedTally: object
}

function TaskDynamicFormOptionsGroup(props: Props) {

    //@ts-ignore
    const selectedGroup = taskHelper.getDistributionGroup(props.taskBoiler.FormDistributeTo)
    const allChecked = selectedGroup ? selectedGroup.allChecked : false

    // console.log("TaskDynamicFormOptionsGroup props", props)
    // console.log("TaskDynamicFormOptionsGroup selectedGroup", selectedGroup)

    const generateTitle = (name: string) => {
        //@ts-ignore
        const sum = props.checkedTally[name]
        const title = (sum && sum > 0) ? `${name} (${sum})` : name
        return title
    }

    return (
        <div className="TaskDynamicFormOptionsGroup">
            <InputGroup>
                <InputGroup.Checkbox
                    checked={allChecked}
                    onChange={() => {
                        //@ts-ignore
                        taskHelper.checkOrUncheckAll(props.taskBoiler.FormDistributeTo)
                        props.manageParentState([{ key: "tasks", value: taskHelper.getTasks() }])
                    }
                    } />
            </InputGroup>
            {props.DistributionGroups.map((group, i: number) =>
                <div className="TaskDynamicFormOptionsGroupItem" key={`task-dynamic-form-options-group-item-${i}`}>
                    <DynamicFormsCustomRadio
                        title={generateTitle(group.Name)}
                        checked={props.taskBoiler.FormDistributeTo === group.Name}
                        callback={() => {
                            let temp = props.taskBoiler
                            temp.FormDistributeTo = group.Name
                            const distributionGroup = taskHelper.getDistributionGroup(temp.FormDistributeTo).data.normalized
                            props.manageParentState([
                                { key: "taskBoiler", value: temp },
                                { key: "distributionGroup", value: distributionGroup },
                                { key: "distributionGroupCopy", value: JSON.parse(JSON.stringify(distributionGroup)) }
                            ])
                        }}
                        overidePalette={true}
                    />
                </div>)}
        </div>
    )
}

export default TaskDynamicFormOptionsGroup